import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=1a90382e&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=ts"
export * from "./TemplateEditor.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=1a90382e&prod&scoped=true&lang=css"
import style1 from "./TemplateEditor.vue?vue&type=style&index=1&id=1a90382e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a90382e",
  null
  
)

export default component.exports